<script setup lang="ts">
import type {Media} from '~/payload-types'

const props = defineProps<{
  node: {
    value: Media | number
    fields?: {caption?: string}
  }
}>()

const media = computed(() => (typeof props.node.value === 'object' ? props.node.value : null))
const isVideo = computed(() => media.value?.mimeType?.startsWith('video/') ?? false)
</script>

<template>
  <figure v-if="media" class="my-6">
    <video
      v-if="isVideo"
      :src="media.url!"
      controls
      muted
      autoplay
      loop
      class="mx-auto max-w-full rounded-lg bordershadow-gray"
    />

    <NuxtPicture
      v-else
      v-bind="resolveMediaProps(media)"
      :width="1280"
      :height="720"
      class="mx-auto rounded-lg"
      loading="lazy"
    />

    <figcaption v-if="node.fields?.caption" class="mt-2 text-center text-sm text-gray-500">
      {{ node.fields.caption }}
    </figcaption>
  </figure>
</template>
